import type { PublicActivation, WhiteLabelConfig } from '@arcual/lib-app-platform';

const port =
  window.location.port !== '80' && window.location.port !== '443' && window.location.port !== ''
    ? `:${window.location.port}`
    : '';
const url = `${window.location.protocol}//${window.location.hostname}${port}`;

export const createActivationHead = (activation: PublicActivation, whiteLabelConfig: WhiteLabelConfig) => ({
  title: activation?.name,
  meta: [
    {
      name: 'description',
      content: whiteLabelConfig.resources.bannerDesktopSlogan,
    },
    {
      name: 'msapplication-TileImage',
      content: whiteLabelConfig.resources.msTile150Url,
    },
    ...createSocialHead(activation, whiteLabelConfig).meta,
  ],
  link: [
    {
      rel: 'manifest',
      id: 'web-manifest',
      href: whiteLabelConfig.resources.manifestUrl,
    },
    {
      rel: 'shortcut icon',
      href: whiteLabelConfig.resources.faviconUrl,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '96x96',
      href: whiteLabelConfig.resources.favicon96Url,
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '128x128',
      href: whiteLabelConfig.resources.favicon128Url,
    },
    {
      rel: 'android-touch-icon',
      // use apple touch icon for both apple & android
      href: whiteLabelConfig.resources.appleTouchIconUrl,
    },
    {
      rel: 'apple-touch-icon',
      href: whiteLabelConfig.resources.appleTouchIconUrl,
    },
    {
      rel: 'apple-touch-icon-precomposed',
      type: 'image/png',
      sizes: '57x57',
      href: whiteLabelConfig.resources.appleTouchIcon57Url,
    },
    {
      rel: 'apple-touch-icon-precomposed',
      type: 'image/png',
      sizes: '72x72',
      href: whiteLabelConfig.resources.appleTouchIcon72Url,
    },
    {
      rel: 'apple-touch-icon-precomposed',
      type: 'image/png',
      sizes: '114x114',
      href: whiteLabelConfig.resources.appleTouchIcon114Url,
    },
    {
      rel: 'apple-touch-icon-precomposed',
      type: 'image/png',
      sizes: '144x144',
      href: whiteLabelConfig.resources.appleTouchIcon144Url,
    },
  ],
});

export const createSocialHead = (activation: PublicActivation, whiteLabelConfig: WhiteLabelConfig) => ({
  meta: [
    {
      property: 'og:site_name',
      content: activation?.name,
    },
    {
      property: 'og:title',
      content: whiteLabelConfig.resources.bannerDesktopSlogan,
    },
    {
      property: 'og:url',
      content: url,
    },
    {
      property: 'og:image',
      content: `${url}/${whiteLabelConfig.resources.socialSharingImage?.url}`,
    },
    {
      property: 'og:image:type',
      content: whiteLabelConfig.resources.socialSharingImage?.type,
    },
    {
      property: 'og:image:width',
      content: whiteLabelConfig.resources.socialSharingImage?.width,
    },
    {
      property: 'og:image:height',
      content: whiteLabelConfig.resources.socialSharingImage?.height,
    },
    {
      property: 'og:image:alt',
      content: whiteLabelConfig.resources.bannerDesktopSlogan,
    },
    {
      property: 'og:description',
      content: whiteLabelConfig.resources.bannerDesktopSlogan,
    },
    {
      name: 'twitter:title',
      content: whiteLabelConfig.resources.bannerDesktopSlogan,
    },
    {
      name: 'twitter:description',
      content: whiteLabelConfig.resources.bannerDesktopSlogan,
    },
    {
      name: 'twitter:image',
      content: `${url}/${whiteLabelConfig.resources.socialSharingImage?.url}`,
    },
  ],
});
